// extracted by mini-css-extract-plugin
export var logo = "_hv-2";
export var logoWrapper = "_hv-1";
export var strip = "_hv-0";